import styled from 'styled-components'

const DebateWindowStyle = styled.div.attrs()`
    padding:var(--sp3x) ;
    background-color: var(--white);
    border:2px solid var(--lightGrey);
    border-radius:10px;
    transition:var(--trTime);
    
    &:hover {
        border-color:var(--purple);
    }
    
    .header {
        .date {
            i {
                font-size: 20px;
                margin-right:var(--spSize);
            }
        }

        .share {
            .lock {
                width:20px;
                padding-top:20px;
                margin-right:12px;

                img {
                    object-fit:contain;
                }
            }

            i {
                font-size: 20px;

                &:nth-child(2) {
                    display: inline-block;
                }

                &:before {
                    transition: 0.3s;
                }
                
                &:hover {
                    &:before {
                        color:var(--purple);
                    }
                }

                &.op-star {
                    &.active {
                        .path1 {
                            &:before {
                                color:#FFDF37;
                            }
                        }
                        
                        .path2 {
                            &:before {
                                color:#FFDF37;
                            }
                        }
                    }

                    &:hover {
                        .path2 {
                            &:before {
                                color:#FFDF37;
                            }
                        }
                    }

                    .path1 {
                        &:before {
                            color:var(--white);
                            transition: var(--trTime);
                        }
                    }
                    
                    .path2 {
                        &:before {
                            transition: var(--trTime);
                            color:var(--darkGrey);
                        }
                    }
                }
            }

            .block {
                position: relative;

                &.share {
                    margin:0 var(--spSize);
                }

                .pop {
                    padding: var(--sp4x);
                    background-color: var(--white);
                    border-radius: 15px;
                    position: absolute;
                    right:0;
                    top: calc(100% + var(--sp1-5x));
                    box-shadow: 0px 0px 10px 4px rgba(0, 0, 0, 0.1);
                    opacity: 0;
                    transition: 0.3s;
                    pointer-events: none;
                    z-index: 10;


                  &.delete {
                    padding: var(--sp2-5x);
                  }  

                    .sharer {
                        transition:var(--trTime);
                        &:hover {
                            color:var(--purple);
                        }
                    }

                    &.active {
                        pointer-events: all;
                        opacity: 1;
                    }

                    a,.comp-title {
                        white-space: nowrap;
                        
                        &:not(:first-child){
                            margin-top: var(--sp2x);
                        }
                    }

                    .comp-title {
                        &:nth-child(2) {
                            margin: var(--sp2x) 0;
                        }
                    }
                }
            }
        }
    }

    .main {
        flex:1;
        margin:var(--sp2-5x) 0;
        padding-bottom: var(--sp3x);
        border-bottom: 1px solid var(--lightGrey);

        .title {
            margin-bottom: var(--sp2-5x);
            /* flex:1; */
            overflow-wrap: anywhere;
        }
        
        .description {
            margin-bottom:var(--spSize);
            overflow-wrap: anywhere;
        }
    }

    .footer {

        i {
            font-size: 20px;
            margin-right: var(--spSize);
        }

        .liked {
            margin-left:var(--sp3x);

            .avatars {
                display:flex;
                flex-direction:row-reverse;

                .imageCont {
                    width: var(--sp4x);
                    height: var(--sp4x);
                    border:2px solid var(--white);
                    border-radius:50%;
                    overflow: hidden;
    
                    &:nth-child(1){
                        z-index: 3;
                        transform: translateX(var(--spSize));
                    }
                    
                    &:nth-child(2){
                        z-index: 2;
                        transform: translateX(var(--sp2x));
                    }
    
                    &:nth-child(3){
                        z-index: 1;
                        transform: translateX(var(--sp3x));
                    }
                }
            }
            

            .comp-title {
                width: var(--sp4x);
                height: var(--sp4x);
                display: flex;
                align-items: center;
                justify-content: center;
                border:2px solid var(--white);
                border-radius:50%;
                z-index: 4;
                color: var(--darkGrey);
                background-color: var(--white);
                position: relative;
                
                &:before {
                    content:'';
                    position: absolute;
                    top:0;
                    left:0;
                    width: 100%;
                    height: 100%;
                    border:1px solid var(--lightGrey);
                    border-radius:50%;
                }
            }
        }
    }



    @media screen and (max-width:${(props) => props.theme.mediaQuery.MobileSize}){
        padding:var(--sp2-5x) ;
        .main {
            margin:var(--sp2x) 0;
            padding-bottom: var(--sp2x);

            .title {
                margin-bottom: var(--sp1-5x);
            }

            .description {
                margin-bottom:var(--sp1-5x);
            }
        }

        .footer {

            /* .like-dislike {
                .like-unlike {
                    max-width: var(--sp15x);
                }
            } */

            .liked {
                margin-left:var(--sp2x);

                .avatars {

                    .imageCont {
                        &:nth-child(3){
                            display: none;
                        }
                    }
                }
            }
        }
    }
`

export default DebateWindowStyle
